import { State } from '@progress/kendo-data-query';
import { useQuery } from '@tanstack/react-query';
import uuid from 'react-uuid';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { InvoiceItems } from 'src/types/Invoices';
import axiosInstance from 'src/utils/axios';

export interface InvoiceFilterRequest {
  companyId: string;
  body: any;
}

export interface InvoiceData {
  items: InvoiceItems[];
  totalRecords: number;
}

async function fetchInvoices({ companyId, body }: InvoiceFilterRequest): Promise<InvoiceData> {
  const response = await axiosInstance.post<InvoiceData>(api.getInvoiceDataUrlFn(companyId), body);
  const data = response.data.items.map((item) => ({ ...item, rowIdentifier: uuid() }));
  return { items: data, totalRecords: response.data.totalRecords };
}

interface UseGetInvoicesQueryOptions {
  companyId: string;
  body: State;
}

const useGetInvoicesQuery = ({ companyId, body }: UseGetInvoicesQueryOptions) => {
  const query = useQuery<InvoiceData>({
    queryKey: [...queryKeys.invoice.list(companyId), body],
    queryFn: () => fetchInvoices({ companyId, body }),
    enabled: !!companyId,
  });

  return query;
};

export default useGetInvoicesQuery;
